import { EmailTypes } from '../authentication/email';
import { XHR } from './xhr';
import { REFRESH_PROFILE_TEMP_SUCCESS } from '../authentication/profileTemp/types';

const XHRMiddleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === 'function') {
        return action(dispatch, getState);
    }

    if (
        action
        && (action.type === EmailTypes.LOGIN_EMAIL_SUCCESS || action.type === EmailTypes.REFRESH_EMAIL_SUCCESS)
    ) {
        const {
            payload: { access_token },
        } = action;

        XHR.defaults.headers.common.Authorization = `Bearer ${access_token}`;
    }

    if (action && (action.type === EmailTypes.LOGIN_EMAIL_FAIL || action.type === EmailTypes.REFRESH_EMAIL_FAIL)) {
        XHR.defaults.headers.common.Authorization = '';
    }

    if (action && action.type === REFRESH_PROFILE_TEMP_SUCCESS) {
        const {
            payload: { xDeviceId },
        } = action;

        XHR.defaults.headers.common['X-Device-Id'] = xDeviceId;
    }

    return next(action);
};

export { XHRMiddleware };
